import type { ReactNode } from "react";
import {
	formFieldLabelClassName,
	formFieldRequiredMarkClassName,
} from "@config/theme/formControls";

export interface FormFieldLabelProps {
	htmlFor?: string;
	children: ReactNode;
	required?: boolean;
	className?: string;
}

const FormFieldLabel = ({ htmlFor, children, required, className }: FormFieldLabelProps) => (
	<label className={className ?? formFieldLabelClassName} htmlFor={htmlFor}>
		{children}
		{required && (
			<>
				{" "}
				<span className={formFieldRequiredMarkClassName}>*</span>
			</>
		)}
	</label>
);

export default FormFieldLabel;
